
import jwt_decode from 'jwt-decode';
import { navigateTo } from "svelte-router-spa";

const AuthService = {
  login: async (email, password) => {
    try {
      const request = await fetch(`${__myapp.env.API_URL}login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email,
          password: password
        })
      });

      const response = await request.json();

      if (!request.ok) {
        return {
          success: false,
          body: response
        }
      }

      localStorage.setItem("token", response.token);

      navigateTo("/");
    }
    catch (error) {
      return {
        error: error,
      };
    }
    /*    try {
         const response = await api.login(email, password)

         if (!response.ok) {
           throw new ApiResponseService(response);
         }

         localStorage.setItem('token', response.data.token);

         return {
           loggedIn: true,
         };

       } catch (error) {
         return {
           error: error,
           loggedIn: false,
         };
       } */
  },

  recovery: async (email) => {
    try {
      const request = await fetch(`${__myapp.env.API_URL}recovery-password`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email,
        })
      });

      const response = await request.json();

      if (!request.ok)
      {
        return {
          success: false,
          body: response
        }
      }
      else
      {
        return {
          success: true,
          body: response
        }
      }

    }
    catch (error) {
      return {
        error: error,
      };
    }
  },

  reset: async (id, password, password_confirmation) => {
    try {
      const request = await fetch(`${__myapp.env.API_URL}reset-password`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          code: id,
          password: password,
          password_confirmation: password_confirmation,
        })
      });

      const response = await request.json();

      if (!request.ok)
      {
        return {
          success: false,
          body: response
        }
      }
      else
      {
        return {
          success: true,
          body: response
        }
      }

    }
    catch (error) {
      return {
        error: error,
      };
    }
  },

  logout: async () => {
    localStorage.clear();
    location.reload();
  },
  isAuthenticated: () => {
    const token = localStorage.getItem('token');

    let isAuth = true;

    if (!token) {
      isAuth = false;
    }

    return isAuth;
  },
  getUser: () => {
    const token = localStorage.getItem('token');

    var decoded = jwt_decode(token);

    return decoded.user;
  },
  getToken: () => {
    const token = localStorage.getItem('token');

    return token;
  },
  isInformer: () => {
    const token = localStorage.getItem('token');

    var decoded = jwt_decode(token);

    return decoded.user.role.name === 'informer'

  },
  isLawyer: () => {
    const token = localStorage.getItem('token');

    var decoded = jwt_decode(token);

    return decoded.user.role.name === 'lawyer'
  }
}

export default AuthService;
